/**
 * Places (areas, residences, landmarks), a placed radius and the areas
 * drawn on the map are all answers to "where" and add up: the search is
 * their union. /listings shows the radius and the drawn areas inside the
 * location control (they have no control of their own there), so
 * clearing that control down to no places clears them too. /map keeps
 * its own radius and draw chips and does not use this.
 */
const PLACE_KEYS = ["location_ids", "complex_slug"] as const;
const RADIUS_KEYS = ["center_lat", "center_lng", "radius_km", "draw"] as const;

export function placeReplacesRadius(
  updates: Record<string, string | string[] | null>,
  current: URLSearchParams,
): Record<string, string | string[] | null> {
  if (RADIUS_KEYS.some((k) => k in updates)) return updates;
  if (!PLACE_KEYS.some((k) => k in updates)) return updates;
  const left = PLACE_KEYS.some((k) => {
    const v = k in updates ? updates[k] : current.getAll(k);
    return (Array.isArray(v) ? v : v ? [v] : []).some(Boolean);
  });
  if (left) return updates;
  return { ...updates, ...Object.fromEntries(RADIUS_KEYS.map((k) => [k, null])) };
}
